import { type Dispatch } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { type Action } from '#types/chat/index.ts'

interface SubmitMessageProps {
	message: string
	messageFetcher: any
	conversationId: string
	dispatch: Dispatch<Action>
	typeOfView: string
}

export const submitMessage = async ({
	message,
	messageFetcher,
	conversationId,
	dispatch,
	typeOfView,
}: SubmitMessageProps) => {
	const newId = uuidv4()
	const formData = new FormData()
	const newUpdatedAtForConversation = new Date()
	formData.append('messageId', newId)
	formData.append('_action', 'user_message')
	formData.append('conversationId', conversationId)
	formData.append('typeOfView', typeOfView)

	formData.append(
		'conversationUpdatedAt',
		newUpdatedAtForConversation.toISOString(),
	)
	formData.append('message', message)
	formData.append('spentTokens', '0')

	await messageFetcher.submit(formData, {
		method: 'post',
	})

	dispatch({
		type: 'CREATE_MESSAGE',
		role: 'user',
		currentMessageProcess: newId,
		payload: message,
		conversationId,
		newUpdatedAt: newUpdatedAtForConversation.toISOString(),
		id: newId,
	})
}
